import { Button, Col, ConfigProvider, Form, Input, Modal, Row,
    Select, Popconfirm, Table, Card} from 'antd';
import Colors from "../../../styles/Colors";
import toast, {Toaster} from "react-hot-toast";
import {BiCheck, BiX, BiPlus, BiPencil, BiTrash} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import {PostDistribucio} from "../../../dao/menudesign/PostDistribucio";
import React, {useContext, useEffect, useState} from 'react';
import {AuthContext} from "../../../config/AuthContext";
import Proveidor from '../../../model/menudesign/Proveidor';
import {ColumnsType} from "antd/es/table";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {DeleteDistribucio} from '../../../dao/menudesign/DeleteDistribucio';
import {GetDistribucionsById} from '../../../dao/menudesign/GetDistribucionsById'
import Distribucio from '../../../model/menudesign/Distribucio';

const { Option } = Select;

interface DistribucionsModalProps {
    element: Proveidor;
    visible: boolean;
    onClose: () => void;
}

const DistribucionsModal: React.FC<DistribucionsModalProps> = ({element, visible, onClose}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const tipus = Form.useWatch('tipus', form);
    const [distribucions, setDistribucions] = useState<Distribucio[]>(element.distribucions || []);
    const [nouElement, setNouElement] = useState(false);
    const [elementSelected, setElementSelected] = useState<Distribucio>(new Distribucio());
    const [coleccio, setDades] = useState<Distribucio[]>([]);

    useEffect(() => {
        setDistribucions(element.distribucions || []);
    }, [element]);

    useEffect(() => {
        if (nouElement) {
            form.setFieldsValue({
                ...elementSelected,
                id_proveidor: element.id
            });
        }
    }, [nouElement]);

    useEffect(() => {
        if (visible) {
            form.resetFields();
            setNouElement(false);
            checkDades();
        }
    }, [visible]);

    
    async function checkDades() {
        const dades = await GetDistribucionsById(page, element.id);
        await setDades(dades);
        
    }
    
    async function handleSubmit() {
        const formData = form.getFieldsValue();
        await PostDistribucio(page, formData, userId);
        //onClose(true);
        toast.success("GUARDAT");
        await checkDades();
        setNouElement(false);
    }

    const handleModalClose = () => {
        form.resetFields();
        setNouElement(false);
        onClose(); // Cierra el modal completamente
    };

    const handleFormCancel = () => {
        form.resetFields();
        setNouElement(false);
        toast.error("NO GUARDAT"); // Solo cierra el formulario interno
    };

    async function deleteElement(distribucio: Distribucio) {
        await DeleteDistribucio(userId, page, distribucio);
        await checkDades();
        setDistribucions(prev => prev.filter(d => d.id !== distribucio.id));
    }

    function togleNouElement(element: Distribucio | null, edit: boolean) {
        setElementSelected(element || new Distribucio());
        setNouElement(true);
    }

    const diesSetmana = ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"];

    const columns: ColumnsType<any> = [
        {
            key: 'tipus',
            title: 'Distribucions',
            dataIndex: 'tipus',
            width: '70%',
            render: (tipus, record) => {
                if (tipus === 1) {
                    return <>Dia del mes: <b>{diesSetmana[record.valor]}</b> cada <b>{record.interv}</b> dies</>;
                } else if (tipus === 0) {
                    return <>Dia de la setmana: <b>{diesSetmana[record.valor]}</b></>;
                } else {
                    return "Tipus desconegut";
                }
            }
        },
        {
            key: 'accions',
            title: 'Accions',
            render: (_text, record) => (
                <>
                    <Popconfirm
                        title="Eliminant"
                        description="Vols eliminar definitivament aquest element?"
                        onConfirm={() => deleteElement(record)}
                        icon={<QuestionCircleOutlined style={{color: 'red'}} />}
                    >
                        <Button title="Eliminar" style={{backgroundColor: Colors.colors.color5}}>
                            <BiTrash/>
                        </Button>
                    </Popconfirm>
                    {" "}
                    <Button
                        title="Editar"
                        style={{backgroundColor: Colors.colors.color6}}
                        onClick={() => togleNouElement(record, true)}
                    >
                        <BiPencil/>
                    </Button>
                </>
            )
        }
    ];

    return (
        
        <ConfigProvider locale={locale}>
            <Toaster/>
            <Modal
                open={visible}
                onCancel={handleModalClose}
                footer={null}
                width="40%"
            >
                <Button
                    title="Crear"
                    style={{backgroundColor: Colors.colors.color2}}
                    onClick={() => togleNouElement(new Distribucio(0,0,0,1,7,element.id,0), false)}
                >
                    <BiPlus/>
                </Button>
                <h3 className="titol">Distribucions</h3>
                <div style={{alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}>
                    <Table
                        rowKey="id"
                        columns={columns}
                        dataSource={coleccio}
                        style={{width: '100%'}}
                    />
                </div>

                {nouElement && (
                    <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <h6>Crear/Editar Distribució</h6>
                        <hr/>
                    <Form form={form} onFinish={handleSubmit} layout="vertical">
                        <Col>
                            <Form.Item name="id" hidden>
                                <Input/>
                            </Form.Item>
                            <Form.Item name="id_proveidor" initialValue={element.id} hidden>
                                <Input type="hidden"/>
                            </Form.Item>
                            <Form.Item label="Proveïdor">
                                <Input value={element.nom} disabled/>
                            </Form.Item>
                            <Form.Item
                                label="Tipus"
                                name="tipus"
                                rules={[{required: true, message: 'Aquest camp és obligatori'}]}
                            >
                                <Select placeholder="Selecciona">
                                    <Option value={1}>Dia al mes</Option>
                                    <Option value={0}>Dia de la setmana</Option>
                                </Select>
                            </Form.Item>

                            {tipus === 1 && (
                                <>
                                    <Form.Item
                                        label="Cada quants dies?"
                                        name="interv"
                                        rules={[{required: true, message: 'Aquest camp és obligatori'}]}
                                    >
                                        <Select placeholder="Selecciona una opció">
                                            <Option value={7}>Setmanal</Option>
                                            <Option value={15}>Quinzenal</Option>
                                            <Option value={30}>Mensual</Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        label="Dia de la setmana"
                                        name="valor"
                                        rules={[{required: true, message: 'Aquest camp és obligatori'}]}
                                    >
                                        <Select placeholder="Selecciona un dia">
                                            {diesSetmana.slice(1, 6).map((dia, index) => (
                                                <Option key={index + 1} value={index + 1}>{dia}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </>
                            )}

                            {tipus === 0 && (
                                <>
                                    <Form.Item
                                        label="Dia de la setmana"
                                        name="valor"
                                        rules={[{required: true, message: 'Aquest camp és obligatori'}]}
                                    >
                                        <Select placeholder="Selecciona un dia">
                                            {diesSetmana.slice(1, 6).map((dia, index) => (
                                                <Option key={index + 1} value={index + 1}>{dia}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item name="interv" initialValue={0} hidden>
                                        <Input type="hidden"/>
                                    </Form.Item>
                                </>
                            )}
                        </Col>
                        <hr/>
                        <Row gutter={[16, 16]}>
                            <Col>
                                <Form.Item>
                                    <Button htmlType="submit" style={{backgroundColor: Colors.colors.color6}}>
                                        <BiCheck/>
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col>
                                <Button style={{backgroundColor: Colors.colors.color1}} onClick={handleFormCancel}>
                                    <BiX/>
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    </Card>
                    </div>
                )}
            </Modal>
        </ConfigProvider>
    );
};

export default DistribucionsModal;
